module.exports = __webpack_public_path__ + "img/ic_completion rate_yellow.f2532091.svg";